import { useStoreData } from '../useStoreData';

export const useOffersData = () => {
    const cmsOffers = useStoreData().storyblok.OfferItems.items;

    return { cmsOffers };
};
